import { createFileRoute } from '@tanstack/react-router'

import { Leads } from '../corpus/Leads'

export const Route = createFileRoute('/admin/leads')({ component: LeadsPage })

/**
 * What the crawls found and could not place.
 *
 * Its own page rather than a panel beside the corpus, because it is not part of
 * the corpus: a lead is a candidate, and the whole point of keeping it out of
 * `companies` is that nothing retrieving evidence can ever see an address nobody
 * has vouched for.
 */
function LeadsPage() {
  return <Leads />
}
